<template>
  <template v-if="canSeeAssistant">
    <li v-if="compact" class="tree__sub" :class="{ active: rightSidebarOpen }">
      <a class="tree__sub-link" href="#" @click.prevent="openPanel">
        <span class="tree__sub-name">{{ $t('copilot.sidebarLabel') }}</span>
      </a>
    </li>
    <li
      v-else
      class="tree__item"
      :class="{ 'tree__item--active': rightSidebarOpen }"
    >
      <div class="tree__action sidebar__action">
        <a class="tree__link" href="#" @click.prevent="openPanel">
          <i class="tree__icon iconoir-chat-bubble"></i>
          <span class="tree__link-text">
            <span class="sidebar__item-name">{{
              $t('copilot.sidebarLabel')
            }}</span>
          </span>
        </a>
      </div>
    </li>
  </template>
</template>

<script>
export default {
  name: 'CopilotSidebarMenuEntry',
  props: {
    compact: {
      type: Boolean,
      default: false,
    },
    workspace: {
      type: Object,
      required: false,
      default: null,
    },
    rightSidebarOpen: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    canSeeAssistant() {
      if (!this.workspace?.id) {
        return false
      }
      return this.$canNavCapability('nav.assistant', this.workspace.id)
    },
  },
  methods: {
    openPanel() {
      this.$bus.$emit('toggle-right-sidebar')
    },
  },
}
</script>
